export const DEFAULT_VARIATION_ID = '@@default@@';
export const OLD_DEFAULT_VARIATION_ID = 'default';
